import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Lenis from "@studio-freight/lenis";

// Component imports

import Footer from "./components/footer/footer";
import Home from "./components/home/home";
import Contactus from "./components/contactus/contactus";
import Navbar from "./components/navbar/navbar";
import Gallery from "./components/gallery/gallery";
import Booking from "./components/booking/booking";
import Aboutus from "./components/aboutus/aboutus";
import Experience from "./components/experience/experience";

// SmoothScroll component
function SmoothScroll({ children }) {
  const lenisRef = useRef();
  const scrollContainerRef = useRef();
  const location = useLocation();
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    if (document.readyState === "complete") {
      setDomLoaded(true);
    } else {
      const onLoad = () => setDomLoaded(true);
      window.addEventListener("load", onLoad);
      return () => window.removeEventListener("load", onLoad);
    }
  }, []);

  useEffect(() => {
    if (!domLoaded) return;

    const timer = setTimeout(() => {
      lenisRef.current = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: "vertical",
        gestureDirection: "vertical",
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
      });

      // Recalculate scroll limits when content changes
      const resizeObserver = new ResizeObserver(() => {
        lenisRef.current?.resize();
      });
      
      // Observe the scroll container to detect content changes
      if (scrollContainerRef.current) {
        resizeObserver.observe(scrollContainerRef.current);
      }

      function raf(time) {
        lenisRef.current?.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);
      
      return () => {
        resizeObserver.disconnect();
      };
    }, 200);

    return () => {
      clearTimeout(timer);
      lenisRef.current?.destroy();
      lenisRef.current = null;
    };
  }, [domLoaded]);

  useEffect(() => {
    if (!lenisRef.current || !domLoaded) return;

    window.scrollTo(0, 0);
    lenisRef.current.stop();

    const resumeTimer = setTimeout(() => {
      lenisRef.current?.start();
    }, 300);

    return () => clearTimeout(resumeTimer);
  }, [location.pathname, domLoaded]);

  return (
    <div ref={scrollContainerRef} className="lenis-wrapper">
      {children}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename="/">
      <SmoothScroll>
        <div className="App scroll">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <Home />
                  <Footer />
                </>
              }
            />
            <Route
              path="/contact-us"
              element={
                <>
                  <Navbar />
                  <Contactus />
                  <Footer />
                </>
              }
            />
            <Route
              path="/gallery"
              element={
                <>
                  <Navbar />
                  <Gallery />
                  <Footer />
                </>
              }
            />
            <Route
              path="/booking"
              element={
                <>
                  <Navbar />
                  <Booking />
                  <Footer />
                </>
              }
            />
            <Route
              path="/about-us"
              element={
                <>
                  <Navbar />
                  <Aboutus />
                  <Footer />
                </>
              }
            />
            <Route
              path="/experience"
              element={
                <>
                  <Navbar />
                  <Experience />
                  <Footer />
                </>
              }
            />
          </Routes>
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
